var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#193755",
    fillRule: "evenodd",
    d: "M25.851 8.218l-.003-.006c-.033-.048-.07-.093-.112-.132L17.647.256c-.006-.006-.015-.01-.02-.016-.037-.034-.074-.063-.114-.09-.015-.01-.03-.016-.045-.025h-.001c-.035-.02-.07-.04-.108-.058-.019-.009-.041-.012-.06-.02V.05c-.034-.013-.07-.023-.104-.032-.06-.011-.119-.017-.179-.017H3.876C1.736.003.003 1.692 0 3.776v22.448C.003 28.308 1.737 29.997 3.876 30h18.248c2.14-.003 3.873-1.692 3.876-3.776V8.697c.001-.102-.018-.202-.057-.297l-.012-.039c-.022-.05-.049-.099-.08-.144zM16.12 1.743v4.05c.003 2.083 1.737 3.772 3.876 3.775h4.216v16.656c0 .539-.22 1.056-.611 1.438-.392.382-.923.595-1.476.595H3.876c-1.152 0-2.087-.91-2.087-2.033V3.776c0-1.122.935-2.033 2.087-2.033H16.12zm3.876 6.082c-1.152 0-2.087-.91-2.087-2.033V2.964l5.027 4.861h-2.94z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3e17e208586549d6336029d1c885a1d4.svg";
export { ForwardRef as ReactComponent };